import BaseService from "../BaseService";

class ChatService extends BaseService {
    listThreads = async ({ page = 1, page_size = 30, info = "" } = {}) => {
        return await this._api.post("/chat/thread/list", { page, page_size, info });
    };

    listMessages = async ({ thread_id, page = 1, page_size = 80 } = {}) => {
        return await this._api.post("/chat/thread/messages", { thread_id, page, page_size });
    };

    getCurrentCartByThread = async ({ thread_id } = {}) => {
        return await this._api.post("/chat/thread/current_cart", { thread_id });
    };

    sendMessage = async ({ thread_id, content = "", attachments = [] } = {}) => {
        return await this._api.post("/chat/thread/send", { thread_id, content, attachments });
    };

    markRead = async ({ thread_id } = {}) => {
        return await this._api.post("/chat/thread/mark_read", { thread_id });
    };

    getLinkPreview = async ({ url } = {}) => {
        return await this._api.post("/chat/link_preview", { url });
    };
}

export default ChatService;